import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import { ADMIN_NAV_ITEMS } from '../../../constants/adminNav';

export default function AdminBreadcrumbs() {
  const { t } = useLanguage();
  const location = useLocation();
  const current = ADMIN_NAV_ITEMS.find((item) => item.path === location.pathname && !item.reserved);
  const crumbs = [{ path: '/admin', label: t('admin.nav.dashboard') }];
  if (current && current.path !== '/admin') {
    crumbs.push({ path: current.path, label: t(current.labelKey) });
  }
  return (
    <nav className="flex flex-wrap items-center gap-1 px-4 pt-3 text-xs text-slate-500">
      {crumbs.map((c, i) => (
        <React.Fragment key={c.path}>
          {i > 0 ? <span>/</span> : null}
          {i === crumbs.length - 1 ? (
            <span className="font-medium text-slate-700">{c.label}</span>
          ) : (
            <Link to={c.path} className="hover:text-indigo-600">
              {c.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
